module.exports = __webpack_public_path__ + "media/packs/images/flags/BL-eac5554bebea7b0f85243578e951d761.png";